import React from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  Alert,
  CircularProgress,
  Avatar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CategoryCards from "./CategoryCards";

import request from "../../../../../utilities/requests";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UserDialog = ({ close, user }) => {
  const [error, setError] = React.useState(null);
  const [imageUrl, setImageUrl] = React.useState(null);
  const [questions, setQuestions] = React.useState([]);
  const [stats, setStats] = React.useState(null);
  const [socialStyles, setSocialStyles] = React.useState(null);

  React.useEffect(() => {
    if (user) {
      getQuestions();
      getSocialStyles();
      getProfilePic();
    }
  }, [user]);

  const getProfilePic = async () => {
    const result = await request(`profile/photo?userId=${user._id}`);
    if (result.success) {
      setImageUrl(result.url);
    }
  };

  const getQuestions = async () => {
    const result = await request(
      `matchmaking/questions?groupByCategory=true&stats=true&userId=${user._id}`
    );
    if (result.success) {
      setQuestions([...result.questions]);
      setStats({ ...result.stats });
      console.log("questions and stats retrieved");
    }
  };

  const getSocialStyles = async () => {
    const result = await request(`matchmaking/socialstyles?userId=${user._id}`);
    if (result.success) {
      setSocialStyles(result.data);
      console.log("social styles retrieved");
    }
  };

  const handleClose = () => {
    setQuestions([]);
    setSocialStyles(null);
    setImageUrl(null);
    close();
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={user ? true : false}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {user?.profile?.firstName} {user?.profile?.lastName}
            </Typography>
          </Toolbar>
        </AppBar>
        <Grid container spacing={1} style={{ padding: 20 }}>
          {error ? (
            <Grid item>
              <Alert severity="error">{error}</Alert>
            </Grid>
          ) : (
            <></>
          )}
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justifyContent="space-around"
            >
              <Grid item>
                <Avatar src={imageUrl} style={{ height: 120, width: 120 }} />
              </Grid>
              <Grid item>
                <Grid container direction="column" spacing={1}>
                  <Grid item>
                    <Typography>{user?.email}</Typography>
                  </Grid>
                  <Grid item>
                    <Typography>Age Range: {user?.profile?.ageRange}</Typography>
                  </Grid>
                  <Grid item>
                    <Typography>Have Children: {user?.profile?.haveChildren}</Typography>
                  </Grid>
                  <Grid item>
                    <Typography>Location: {user?.profile?.location}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CategoryCards
              stats={stats}
              questions={questions}
              socialStyles={socialStyles}
              userId={user?._id}
            />
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export default UserDialog;
